import React, { useEffect } from 'react';
import styled from 'styled-components';
import FeedbackDashboardFilterSelect from 'shared/components/Feedback/FeedbackDashboardFilterSelect';
import { LocalizationProvider, CalendarPicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { faCalendarDays } from '@fortawesome/pro-light-svg-icons';
import { TrueImpactButtonWithLoading } from 'shared/design-system/components/TrueImpactButton';

type MaterialUiPickersDate = Date | null;

interface DateSelectorProps {
  date: MaterialUiPickersDate | undefined;
  handleDate: (date: MaterialUiPickersDate) => unknown;
  optionsMap: Record<string, () => void>;
  className?: string;
  recencyDate?: MaterialUiPickersDate;
}

const StyledDiv = styled.div`
  overflow: hidden;
  background-color: ${COLORS.whiteBase};
  padding: ${SPACERS.tiny} ${SPACERS.small};
  .select-button {
    margin-top: ${SPACERS.tiny};
    margin-bottom: ${SPACERS.tiny};
  }
`;

const DateSelector: React.FC<DateSelectorProps> = ({
  date,
  className,
  handleDate,
  optionsMap,
  recencyDate,
}) => {
  // Defaults as lowest option that is not 'No constraint'
  const [, setSelected] = React.useState(Object.keys(optionsMap)[1]);
  const onClose = () => null;
  const handleClear = (handleClose: () => unknown) => {
    handleDate(null);
    handleClose();
  };

  useEffect(() => {
    if (!recencyDate) {
      setSelected(Object.keys(optionsMap)[0]);
    }
  }, [recencyDate]);

  return (
    <FeedbackDashboardFilterSelect
      type="select"
      selectorLabel="Date Selector"
      icon={faCalendarDays}
      disableClearButton={!date}
      clearButtonText="Clear date filter"
      onClearAll={handleClear}
      onClose={onClose}
      Component={undefined}
      className={className}
    >
      {/* Recency filter hidden - restore block below to re-enable
      <FeedbackDashboardFilterSelect
        type="radio"
        selectorLabel="Recency"
        icon={faCalendarDays}
        disableClearButton={!date}
        onClearAll={undefined}
        onClose={undefined}
        Component={Component}
        className={`${className}-recency`}
      />
      <div
        className="heading-label"
        style={{ padding: SPACERS.tiny, textAlign: 'center' }}
      >
        OR{' '}
      </div>
      */}
      <StyledDiv>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          {date ? (
            <CalendarPicker
              date={date || new Date()}
              onChange={date => {
                handleDate(date);
                setSelected(Object.keys(optionsMap)[0]);
                optionsMap['No Time Constraint']();
              }}
            />
          ) : (
            <TrueImpactButtonWithLoading
              variant="secondary-large"
              className="select-button"
              onClick={() => {
                handleDate(new Date());
                setSelected(Object.keys(optionsMap)[0]);
                optionsMap['No Time Constraint']();
              }}
            >
              Pick a date
            </TrueImpactButtonWithLoading>
            // add in dropdown
          )}
        </LocalizationProvider>
      </StyledDiv>
    </FeedbackDashboardFilterSelect>
  );
};

export default DateSelector;
